import React,{ useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ServiceEdit1 from "./Components/ServiceEdit1";
import Loader from "./Components/Loader";

const ServiceEditPage1=()=>{
    useEffect(()=>{
        document.title="Edit Service | Balaji Badminton Academy"
      },[]);

    return(
        <>
            <Header/>
            <Loader/>
            <ServiceEdit1/>
            <Footer/>
        </>
    );
}

export default ServiceEditPage1;